import React from 'react';
import { connect } from 'react-redux';
import { Selection } from '@leverege/ui-redux';
import { LayerCreator } from '@leverege/ui-mapbox-elements';
import GeoPointModel from "./GeoPointModel.js";
import GeoPointAdapter from "./GeoPointAdapter.js";
class GeoPointRenderer extends React.Component {
  constructor(options) {
    super(options);
    const {
      relationship,
      attributeName,
      layerId
    } = options;
    const {
      path,
      ref,
      objectType
    } = relationship;
    const id = layerId || `${path}:${attributeName}`;
    this.adapter = new GeoPointAdapter({
      attributeName
    }); // Your specific shapes' styling and data access
    this.points = new LayerCreator({
      id,
      // Give prefix for layer types
      dataType: objectType,
      // Give type of dataTypes
      dataRef: ref,
      // Give type of dataTypes
      adapter: this.adapter // Give adapter
    });
    this.sIds = [`${id}-fill`, `${id}-fill-selected`, `${id}-fill-rollover`, `${id}-sym`, `${id}-sym-selected`, `${id}-sym-rollover`];
  }
  render() {
    const {
      items,
      interaction,
      rollover,
      selected,
      symbols,
      order,
      model,
      map,
      ...extraData
    } = this.props;
    const isVisible = model ? GeoPointModel.getVisible(model) : true;
    let isRolloverable = model ? GeoPointModel.getRolloverable(model) : true;
    let isSelectable = model ? GeoPointModel.getSelectable(model) : true;
    if (isVisible === false) {
      return [];
    }
    const showAt = model ? GeoPointModel.getShowAtZoom(model) : null;
    const hideAt = model ? GeoPointModel.getHideAtZoom(model) : null;
    const startInteractionAt = model ? GeoPointModel.getStartInteractionAtZoom(model) : null;
    const stopInteractionAt = model ? GeoPointModel.getStopInteractionAtZoom(model) : null;
    const zoom = map?.getZoom() || 0;
    // console.log( this.props.relationship.path, 'zoom', zoom, 'show', showAt, 'hide', hideAt)

    // We cant do the following because the dynamic renderer will not have anything to draw
    // if ( typeof showAt === 'number' && showAt > zoom ) { return [] }
    // if ( typeof hideAt === 'number' && hideAt < zoom ) { return [] }
    if (typeof showAt === 'number' && showAt > zoom || typeof hideAt === 'number' && hideAt < zoom || typeof startInteractionAt === 'number' && startInteractionAt > zoom || typeof stopInteractionAt === 'number' && stopInteractionAt < zoom) {
      isRolloverable = false;
      isSelectable = false;
    }
    const opts = {
      ...extraData,
      symbols,
      rollover,
      selected,
      model,
      order
    }; // Add rollover and selected to allow highlighting
    // Add/Remove this as a selectable/rollover
    interaction[isSelectable ? 'addSelectableId' : 'removeSelectableId'](this.sIds);
    interaction[isRolloverable ? 'addRolloverId' : 'removeRolloverId'](this.sIds);

    //  console.log( 'GPR-items', this.props.relationship.path, items, this.props )
    return this.points.getLayers(items, opts);
  }
}
export default connect((state, props) => {
  // Do some calculation/data retreival as necessary
  return {
    selected: Selection.get(state, 'selected'),
    rollover: Selection.get(state, 'rollover'),
    mapEditing: Selection.get(state, 'mapEditing')
  };
})(GeoPointRenderer);